export const section = {
    title: "Image Gallery",
    subTitle:
        "Images that tell our company's story: events, culture, and successes.",
    categories: ["All", "2025"],
    images: [
        {
            name: "DSC08140.webp",
            delay: "100",
            url: "/assets/image-gallery/DSC08140.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-8",
            delay: "100",
            url: "/assets/image-gallery/DSC08166.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-9",
            delay: "100",
            url: "/assets/image-gallery/DSC08192.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-9-2026",
            delay: "200",
            url: "/assets/image-gallery/DSC08219.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2026",
            delay: "200",
            url: "/assets/image-gallery/DSC08291.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-8-2026",
            delay: "200",
            url: "/assets/image-gallery/DSC08300.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-8-2027",
            delay: "300",
            url: "/assets/image-gallery/DSC08327.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-9-2027",
            delay: "300",
            url: "/assets/image-gallery/DSC08354.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "300",
            url: "/assets/image-gallery/DSC08380.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "400",
            url: "/assets/image-gallery/DSC08382.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "400",
            url: "/assets/image-gallery/DSC08399.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "400",
            url: "/assets/image-gallery/DSC08418.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "500",
            url: "/assets/image-gallery/DSC08421.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "500",
            url: "/assets/image-gallery/DSC08436.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "500",
            url: "/assets/image-gallery/DSC08449.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "600",
            url: "/assets/image-gallery/DSC08454.webp",
            category: "2025",
        },
        {
            name: "masonry-portfolio-7-2027",
            delay: "600",
            url: "/assets/image-gallery/DSC08455.webp",
            category: "2025",
        },
    ],
};
